// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as CountryHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/CountryHelpers.mjs";
import * as PartnersDataSource$PorterinFeature from "../data-source/PartnersDataSource.mjs";
import * as PartnersRepoConfig$PorterinFeature from "./PartnersRepoConfig.mjs";
import * as Network$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/Network.mjs";
import * as ApiUtils$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ApiUtils.mjs";

var dummyContentData = {
"data": {
"id": 1,
"attributes": {
"createdAt": "2024-06-25T20:42:24.951Z",
"updatedAt": "2024-06-25T22:45:46.214Z",
"publishedAt": "2024-06-25T20:42:37.308Z",
"locale": "en",
"hero_section": {
"id": 3,
"title": "lorem",
"sub_text": "lorem",
"banner_img_mobile": {
"id": 35,
"alt_text": "lorem",
"image": {
"data": {
"id": 7,
"attributes": {
"name": "from-input.svg",
"alternativeText": null,
"caption": null,
"width": 16,
"height": 16,
"formats": null,
"hash": "from_input_ba84752e6a",
"ext": ".svg",
"mime": "image/svg+xml",
"size": 0.15,
"url": "https://nest-platform-staging-cdn.porter.in/large_intercity_banner_bf6222c42d_30f5850464.webp",
"previewUrl": null,
"provider": "local",
"provider_metadata": null,
"createdAt": "2024-06-12T07:44:01.690Z",
"updatedAt": "2024-06-23T10:41:18.240Z"
}
}
}
},
"know_more_cta": {
"id": 7,
"label": "lorem",
"href": "lorem"
},
"banner_img": {
"id": 34,
"alt_text": "lorem",
"image": {
"data": {
"id": 7,
"attributes": {
"name": "from-input.svg",
"alternativeText": null,
"caption": null,
"width": 16,
"height": 16,
"formats": null,
"hash": "from_input_ba84752e6a",
"ext": ".svg",
"mime": "image/svg+xml",
"size": 0.15,
"url": "https://nest-platform-staging-cdn.porter.in/large_intercity_banner_bf6222c42d_30f5850464.webp",
"previewUrl": null,
"provider": "local",
"provider_metadata": null,
"createdAt": "2024-06-12T07:44:01.690Z",
"updatedAt": "2024-06-23T10:41:18.240Z"
}
}
}
}
},
"porter_advantage": {
"id": 1,
"title": "lorem",
"cards": [
{
"id": 1,
"title": "tiitle",
"desc": "desc",
"icon": {
"data": {
"id": 7,
"attributes": {
"name": "from-input.svg",
"alternativeText": null,
"caption": null,
"width": 16,
"height": 16,
"formats": null,
"hash": "from_input_ba84752e6a",
"ext": ".svg",
"mime": "image/svg+xml",
"size": 0.15,
"url": "https://nest-platform-staging-cdn.porter.in/large_intercity_banner_bf6222c42d_30f5850464.webp",
"previewUrl": null,
"provider": "local",
"provider_metadata": null,
"createdAt": "2024-06-12T07:44:01.690Z",
"updatedAt": "2024-06-23T10:41:18.240Z"
}
}
}
}
]
},
"life_easy_section": {
"id": 2,
"title": "tiitle",
"desc": "desc",
"icon": {
"data": {
"id": 7,
"attributes": {
"name": "from-input.svg",
"alternativeText": null,
"caption": null,
"width": 16,
"height": 16,
"formats": null,
"hash": "from_input_ba84752e6a",
"ext": ".svg",
"mime": "image/svg+xml",
"size": 0.15,
"url": "https://nest-platform-staging-cdn.porter.in/large_intercity_banner_bf6222c42d_30f5850464.webp",
"previewUrl": null,
"provider": "local",
"provider_metadata": null,
"createdAt": "2024-06-12T07:44:01.690Z",
"updatedAt": "2024-06-23T10:41:18.240Z"
}
}
}
},
"additioanal_benifits": {
"id": 2,
"title": "lorem",
"cards": [
{
"id": 3,
"title": "tiitle",
"desc": "desc",
"icon": {
"data": {
"id": 7,
"attributes": {
"name": "from-input.svg",
"alternativeText": null,
"caption": null,
"width": 16,
"height": 16,
"formats": null,
"hash": "from_input_ba84752e6a",
"ext": ".svg",
"mime": "image/svg+xml",
"size": 0.15,
"url": "https://nest-platform-staging-cdn.porter.in/large_intercity_banner_bf6222c42d_30f5850464.webp",
"previewUrl": null,
"provider": "local",
"provider_metadata": null,
"createdAt": "2024-06-12T07:44:01.690Z",
"updatedAt": "2024-06-23T10:41:18.240Z"
}
}
}
}
]
},
"testimonial_section": {
"id": 1,
"title": "lorem",
"profiles": [
{
"id": 1,
"name": "lorem",
"city": "lorem",
"description": "lorem",
"image": {
"data": {
"id": 7,
"attributes": {
"name": "from-input.svg",
"alternativeText": null,
"caption": null,
"width": 16,
"height": 16,
"formats": null,
"hash": "from_input_ba84752e6a",
"ext": ".svg",
"mime": "image/svg+xml",
"size": 0.15,
"url": "https://nest-platform-staging-cdn.porter.in/large_intercity_banner_bf6222c42d_30f5850464.webp",
"previewUrl": null,
"provider": "local",
"provider_metadata": null,
"createdAt": "2024-06-12T07:44:01.690Z",
"updatedAt": "2024-06-23T10:41:18.240Z"
}
}
}
},
{
"id": 2,
"name": "lorem",
"city": "lorem",
"description": "lorem",
"image": {
"data": {
"id": 7,
"attributes": {
"name": "from-input.svg",
"alternativeText": null,
"caption": null,
"width": 16,
"height": 16,
"formats": null,
"hash": "from_input_ba84752e6a",
"ext": ".svg",
"mime": "image/svg+xml",
"size": 0.15,
"url": "https://nest-platform-staging-cdn.porter.in/large_intercity_banner_bf6222c42d_30f5850464.webp",
"previewUrl": null,
"provider": "local",
"provider_metadata": null,
"createdAt": "2024-06-12T07:44:01.690Z",
"updatedAt": "2024-06-23T10:41:18.240Z"
}
}
}
}
]
},
"faq_section": {
"id": 3,
"title": "lorem",
"sub_text": "lorem",
"toggle_icon": {
"id": 36,
"alt_text": "lorem",
"image": {
"data": {
"id": 9,
"attributes": {
"name": "to-input.svg",
"alternativeText": null,
"caption": null,
"width": 16,
"height": 16,
"formats": null,
"hash": "to_input_657c3929c4",
"ext": ".svg",
"mime": "image/svg+xml",
"size": 0.42,
"url": "https://nest-platform-staging-cdn.porter.in/large_intercity_banner_bf6222c42d_30f5850464.webp",
"previewUrl": null,
"provider": "local",
"provider_metadata": null,
"createdAt": "2024-06-12T07:44:01.694Z",
"updatedAt": "2024-06-12T07:44:01.694Z"
}
}
}
},
"faqs": [
{
"id": 3,
"question": "lorem",
"answer": "lorem"
}
]
},
"download_app": {
"id": 5,
"title": "tiitle",
"desc": "desc",
"icon": {
"data": {
"id": 7,
"attributes": {
"name": "from-input.svg",
"alternativeText": null,
"caption": null,
"width": 16,
"height": 16,
"formats": null,
"hash": "from_input_ba84752e6a",
"ext": ".svg",
"mime": "image/svg+xml",
"size": 0.15,
"url": "https://nest-platform-staging-cdn.porter.in/large_intercity_banner_bf6222c42d_30f5850464.webp",
"previewUrl": null,
"provider": "local",
"provider_metadata": null,
"createdAt": "2024-06-12T07:44:01.690Z",
"updatedAt": "2024-06-23T10:41:18.240Z"
}
}
}
},
"partner_own_vehicle": {
"id": 1,
"title": "lorem",
"sub_title": "lorem",
"action": {
"id": 4,
"href": "lorem",
"label": "lorem",
"target": "_blank",
"isExternal": true
},
"image": {
"id": 37,
"alt_text": "lorem",
"image": {
"data": {
"id": 7,
"attributes": {
"name": "from-input.svg",
"alternativeText": null,
"caption": null,
"width": 16,
"height": 16,
"formats": null,
"hash": "from_input_ba84752e6a",
"ext": ".svg",
"mime": "image/svg+xml",
"size": 0.15,
"url": "https://nest-platform-staging-cdn.porter.in/large_intercity_banner_bf6222c42d_30f5850464.webp",
"previewUrl": null,
"provider": "local",
"provider_metadata": null,
"createdAt": "2024-06-12T07:44:01.690Z",
"updatedAt": "2024-06-23T10:41:18.240Z"
}
}
}
}
},
"meta_data": {
"id": 5,
"title": "lorem",
"description": "lorem",
"faq_schema": null,
"review_schema": null,
"local_business_schema": null
}
}
},
"meta": {}
};

var dummyVehicleTypesResponse = {
  "vehicle":{
    "2 Wheeler": 97,
    "3 Wheeler": 91,
    "3 Wheeler Electric": 127,
    "E Loader": 126,
    "Others": 20,
    "Pickup 1.7Ton": 128,
    "Pickup / Dost / Super Ace / 8ft": 9,
    "Tata 17ft": 4,
    "Tata 407": 2,
    "Tata 407 14ft": 3,
    "Tata Ace": 1
  }
};

function fetchPartnerVehicles(geo_region_id) {
  return Js_promise.then_((function (result) {
                return Js_promise.then_((function (result) {
                              if (result.TAG === /* Ok */0) {
                                return Promise.resolve({
                                            TAG: /* Ok */0,
                                            _0: result._0
                                          });
                              }
                              var catalystError = /* DefaultError */{
                                _0: {
                                  title: /* Unauthorized */1,
                                  message: result._0._0.message
                                }
                              };
                              return Promise.resolve({
                                          TAG: /* Error */1,
                                          _0: catalystError
                                        });
                            }), ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                                return Curry._1(PartnersRepoConfig$PorterinFeature.PartnerVehiclesApiResponseConverter.execute, result);
                              }));
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: dummyVehicleTypesResponse
                        });
                  })));
}

function getMainPageContent(locale) {
  var country = CountryHelpers$PorterinUtils.countryCodeFromLocale(locale);
  var requestUrl = PartnersDataSource$PorterinFeature.getPartnersCMSUrl(country, locale);
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PartnersRepoConfig$PorterinFeature.PartnersContentApiResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.getRequestV2(requestUrl, undefined, undefined, undefined));
}

var dummyPartnersFormSubmissionResponse = {
      "message": "Thanks for showing your interest in Porter! We have received your request, Our team will revert you within next 48 hours with the onboarding process at porter. In the meanwhile, you can visit our city office from Monday to Friday between 11:00am to 04:30pm, Office Address : M/s: Smartshift Logistics Solutions Pvt. Ltd., (PORTER), 3rd floor,Shri Krishna Akshaya Mansion, 1st Phase, 27th Main,100 Feet Road,BTM Layout, Bengaluru - 560 068, Landmark: Opp: Gangothri Hospital",
      "name": "Porter473"
    };

function submitAttachVehicleForm(form) {
  return Js_promise.then_((function (result) {
                return Js_promise.then_((function (result) {
                              if (result.TAG === /* Ok */0) {
                                return Promise.resolve({
                                            TAG: /* Ok */0,
                                            _0: result._0
                                          });
                              }
                              var catalystError = /* DefaultError */{
                                _0: {
                                  title: /* Unauthorized */1,
                                  message: result._0._0.message
                                }
                              };
                              return Promise.resolve({
                                          TAG: /* Error */1,
                                          _0: catalystError
                                        });
                            }), ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                                return Curry._1(PartnersRepoConfig$PorterinFeature.PartnerFormApiResponseConverter.execute, result);
                              }));
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: dummyPartnersFormSubmissionResponse
                        });
                  })));
}

export {
  dummyContentData ,
  dummyVehicleTypesResponse ,
  fetchPartnerVehicles ,
  getMainPageContent ,
  dummyPartnersFormSubmissionResponse ,
  submitAttachVehicleForm ,
}
/* PartnersDataSource-PorterinFeature Not a pure module */
